import { getIdb, getMe } from "../bridges/methods";
import { BusinessAppointmentConfigs } from "@elixir/types";
import dayjs from "dayjs";
import { track } from "../tracking";
import { QUEUE_CONFIG_KEY } from "../../constants/config";
import { initAptListener } from "../firestore-utils/apt-listener-manager";
import getB from "../bridges/EkaBridge";

export async function refreshAppts({ clinicId }: { clinicId: string }) {
  try {
    initAptListener({ clinicId, docids: getB().getMe()?.docs.map(t=> t.id) });
    return true;
  } catch (e) {
    console.log("ERROR =====> refreshAppts", e);
    track("REFRESH_APPT_FAIL", { source: "OUTSIDE_APT_REFETCH" });
    return false;
  }
}
